import React, { useEffect, useState } from "react";
import Cards from "./Cards";
import Header from "./Header";
import styles from "./Body.module.css";
import BarChartComponent from "./BarChartComponent";
import Setting from "./Setting";
import ManageSpecialist from "./manage specialist/ManageSpecialist";
import axios from "axios";
import { GET_ANALYTICS } from "../utils/constants";

const Body = ({ activeTab }) => {
  const [analyticsData, setAnalyticsData] = useState(null);

  useEffect(() => {
    if (activeTab === "Dashboard") {
      fetchData();
    }
  }, [activeTab]);

  const fetchData = async () => {
    try {
      const response = await axios.get(GET_ANALYTICS);
      setAnalyticsData(response.data.data);
    } catch (error) {
      console.error("Error fetching analytics data:", error);
    }
  };

  return (
    <div>
      <div className={styles.Body_parent}>
        <Header />
        {activeTab === "Dashboard" && (
          <div>
            <div className={styles.Analytics_container}>
              <p className={styles.Analytics_text}>Analytics</p>
              <p className={styles.view_all_btn}>View All Users</p>
            </div>
            <div className={styles.chart_and_card}>
              <BarChartComponent analyticsData={analyticsData} />
              <div className={styles.cards_parent}>
                <Cards
                  title="Response time By AI"
                  time={analyticsData?.aiAvgResponceTime}
                />
                <Cards
                  title="Response time By AI"
                  time={analyticsData?.specialistAvgResponceTime}
                />
              </div>
            </div>
          </div>
        )}
        {activeTab === "Block" && <Setting />}
        {activeTab === "Settings" && <ManageSpecialist />}
      </div>
    </div>
  );
};

export default Body;
